import { useAPI } from "~/uses/useMyFetch";
import { useMemoize } from "@vueuse/core";
import { Product } from "~/models/product.model";

export const useFavoriteProductStore = defineStore("favoriteProductStore", {
  state: () => {
    return {
      products: [],
      memoizedFetch: null,
    };
  },
  actions: {
    async forceFetch() {
      useAPI("/catalog/product/list/favorite").then((data) => {
        this.products = data.map(({ product }) => new Product(product));
      });
    },
    async fetch() {
      if (null === this.memoizedFetch) {
        this.memoizedFetch = useMemoize(this.forceFetch);
      }

      return this.memoizedFetch();
    },
    async addProduct(productId) {
      await useAPI("/catalog/product/favorite/add", {
        method: "POST",
        body: { productId },
      });

      await this.forceFetch();
    },
    async removeProduct(productId) {
      await useAPI("/catalog/product/favorite/remove", {
        method: "POST",
        body: { productId },
      });

      await this.forceFetch();
    },
    resetFavorites() {
      this.products = [];
    },
  },
  getters: {
    getIsProductInList: (state) => {
      return (id) => {
        return state.products.some((product) => product.id === id);
      };
    },
    getProducts: (state) => state.products,
    getProductsLength: (state) => state.products.length,
  },
});
